(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings",
            {
                url: "/Settings",
                PageTitle: "Settings",
                component: "settings"               
            });
        }
    ]);

    app.component("settings",
    {
        templateUrl: "App/Settings/settings.html",
        controller: settingsCtrl
    });

    settingsCtrl.$inject = [];


    function settingsCtrl() {

    }

})(window.app); // jshint ignore:line